"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AvatarGroup_st_css_1 = require("./AvatarGroup.st.css");
var Avatar_1 = require("../Avatar");
var AvatarGroupTextButton_1 = require("./AvatarGroupTextButton");
var TextButton_1 = require("../TextButton");
var AvatarGroupSize;
(function (AvatarGroupSize) {
    AvatarGroupSize["large"] = "large";
    AvatarGroupSize["medium"] = "medium";
    AvatarGroupSize["small"] = "small";
    AvatarGroupSize["xSmall"] = "xSmall";
    AvatarGroupSize["xxSmall"] = "xxSmall";
})(AvatarGroupSize = exports.AvatarGroupSize || (exports.AvatarGroupSize = {}));
/** The Avatar group is made up of a group of avatars and an optional text link. Content in text link can be customized to the product's intent. */
var AvatarGroup = /** @class */ (function (_super) {
    __extends(AvatarGroup, _super);
    function AvatarGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTextButton = function () {
            var children = _this.props.children;
            var textButton = React.Children.toArray(children).find(function (child) {
                return React.isValidElement(child) &&
                    (child.type === TextButton_1.TextButton || child.type === AvatarGroupTextButton_1.AvatarGroupTextButton);
            });
            if (textButton) {
                return React.cloneElement(textButton, {
                    className: (textButton.props.className || '') + " " + AvatarGroup_st_css_1.default.textButton,
                    'data-hook': 'text-button',
                });
            }
        };
        return _this;
    }
    AvatarGroup.prototype.render = function () {
        var _a = this.props, items = _a.items, size = _a.size, maxAmount = _a.maxAmount, rest = __rest(_a, ["items", "size", "maxAmount"]);
        var textButton = this.getTextButton();
        return (React.createElement("div", __assign({}, AvatarGroup_st_css_1.default('root', { size: size }, rest)),
            React.createElement("div", { className: AvatarGroup_st_css_1.default.avatars }, items.slice(0, maxAmount).map(function (_a, key) {
                var name = _a.name, src = _a.src, onLoad = _a.onLoad;
                return (React.createElement("div", { className: AvatarGroup_st_css_1.default.avatarContainer, key: key },
                    React.createElement(Avatar_1.Avatar, { className: AvatarGroup_st_css_1.default.avatar, "data-hook": "avatar", name: name, src: src, onLoad: onLoad })));
            })),
            textButton ? (React.createElement("div", { className: AvatarGroup_st_css_1.default.textButtonContainer }, textButton)) : null));
    };
    AvatarGroup.displayName = 'AvatarGroup';
    AvatarGroup.defaultProps = {
        items: [],
        maxAmount: 5,
        size: AvatarGroupSize.medium,
    };
    AvatarGroup.TextButton = AvatarGroupTextButton_1.AvatarGroupTextButton;
    return AvatarGroup;
}(React.Component));
exports.AvatarGroup = AvatarGroup;
//# sourceMappingURL=AvatarGroup.js.map